/*
 * @Author: scg
 * @Date: 2021-12-10 14:54:44
 * @LastEditTime: 2022-03-07 15:56:55
 * @LastEditors: scg
 * @Description:
 */
import axios from 'axios'
import config from '@/config'
import i18n from "@/langurage/i18n";
// import { Message } from 'element-ui'
// import store from '@/store'
// 创建axios
const service = axios.create({
  // 这里baseurl就是刚开始配置的开发环境和线上环境地址，webpack会自动读取无需手动再改
  baseURL: config.baseURL, // baseurl
  timeout: 60000 // 请求超时
})

// request拦截
// 请求拦截主要作用是验证请求是否合法，会带有用户token，这里模拟一个token，可以根据实际情况修改
service.interceptors.request.use(
  config => {
    config.headers['language'] = localStorage.getItem('locale') || i18n.locale;
    if (config.url === 'api/user/login' ||
      config.url === 'api/Ems/send' ||
      config.url === 'api/user/resetpwd' ||
      config.url === 'api/index/get_termsofuse' ||
      config.url === 'api/user/login') {
      return config
    } else {
      config.headers['token'] = localStorage.getItem('token')
      return config
    }
  },
  err => {
    console.log(err)
    Promise.reject(err)
  }
)

// respone拦截
// 响应拦截主要是对返回做统一处理
service.interceptors.response.use(
  response => {
    let res = response.data
    let { data, code } = res
    // console.log(response)
    if (code !== 200) {
      // Message({
      //   message: res.data.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      if (res.code === 401) {
        window.location.href = '/login'
      }
      return res
    } else {
      // 这里吧错误响应不再返回到页面，直接统一处理掉，只有正确的返回才会被接收并做下一步处理
      return data
    }
  },
  err => {
    // 这里处理服务端错误
    console.log('err' + err) // for debug
    // Message({
    //   message: err.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(err)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/tools/request.js